"use client"

import { useEffect } from "react"
import Link from "next/link"
import { Button } from "@/components/ui/button"
import posthog from "posthog-js"

export default function AppError({ error, reset }) {
  useEffect(() => {
    posthog.captureException(error, { boundary: "app" })
  }, [error])

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center space-y-4 max-w-md">
        <h2 className="text-xl font-semibold">Something went wrong</h2>
        <p className="text-muted-foreground text-sm">
          An error occurred while loading this page. You can try again or go back to the question browser.
        </p>
        <div className="flex gap-2 justify-center">
          <Button onClick={reset}>Try again</Button>
          <Button variant="outline" asChild>
            <Link href="/app">Back to questions</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
